import React, { useEffect, useState } from "react";
import { jarallax, jarallaxElement } from "jarallax";
import 'jarallax/dist/jarallax.css';
import 'jarallax/dist/jarallax.min.js';
import 'jarallax/dist/jarallax-element.min.js';
import "jquery-ui-dist/jquery-ui";
import axiosInstance from '../axiosConfig';
import { NavLink } from 'react-router-dom';

const Footer = () => {

    const [isVisible, setIsVisible] = useState(false);
    const [loading, setLoading] = useState(true); 
    const [facebook, setFacebook] = useState(null);
    const [twitter, setTwitter] = useState(null);
    const [instagram, setInstagram] = useState(null);

     useEffect(() => {
         const fetchSettings = async () => {
             try {
                 const response = await axiosInstance.get('/general-settings');
                 if (response.data.success) {
                     response.data.settings.forEach(setting => {
                         if (setting.key === 'facebook_link') {
                            setFacebook(setting.value);
                         }
                         if (setting.key === 'twitter_link') {
                            setTwitter(setting.value);
                         }
                         if (setting.key === 'instagram_link') {
                            setInstagram(setting.value);
                         }
                     });
                 }
             } catch (error) {
                 console.error("Error fetching settings:", error);
             } finally {
                 setLoading(false);
             }
         };
 
         fetchSettings();
     }, []);
 

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <NavLink className={`scroll-to-top-btn ${isVisible ? 'visible' : ''}`} onClick={scrollToTop}></NavLink>
            <footer>
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-md-3 col-lg-4">
                            <img src="assets/images/logo.png" className="" alt="" />
                        </div>
                        <div className="col-md-9 col-lg-8 text-md-end">
                        <div className="social-icons">
                                {/* <NavLink to="" target="_blank"><i className="fa-brands fa-facebook-f"></i></NavLink>
                                <NavLink to="" target="_blank"><i className="fa-brands fa-x-twitter"></i></NavLink>
                                <NavLink to="" target="_blank"><i className="fa-brands fa-instagram"></i></NavLink> */}

                                <NavLink 
                                    to={facebook ? facebook : 'https://www.facebook.com/YourDefaultPage'} 
                                    target="_blank">
                                    <i className="fa-brands fa-facebook-f"></i>
                                </NavLink>

                                <NavLink 
                                    to={twitter ? twitter : 'https://twitter.com/YourDefaultPage'} 
                                    target="_blank">
                                    <i className="fa-brands fa-x-twitter"></i>
                                </NavLink>
                                
                                <NavLink 
                                    to={instagram ? instagram : 'https://www.instagram.com/YourDefaultPage'} 
                                    target="_blank">
                                    <i className="fa-brands fa-instagram"></i>
                                </NavLink>
                            </div>
                            <div className="terms">
                                <ul>
                                    <li>
                                        <NavLink to="/privacy-policy">Privacy Policy</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/refund-cancellation-policy">Refund & Cancellation Policy</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/terms-conditions">Terms and Conditions</NavLink>
                                    </li>
                                </ul>
                            </div>
                            2024 © All Rights Reserved. The Cutting Bar
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;
